import { useRouter } from 'next/router'
import GradientButton from '../Buttons/GradientButton'
import YoutubeEmbed from '../YoutubeEmbed'

export default function JustinStory() {
    const router = useRouter()

    const handleClick = () => {
        router.push('/products')
    }

    return (
        <div className="max-w-full w-[1200px] mx-auto mt-4 mb-16 text-center p-4 md:space-y-8 space-y-4">
            <div className="md:space-y-0 space-y-4">
                <h4 className="text-3xl/[1.15] font-bold text-olm">
                    Success Story
                </h4>
                <h3 className="md:text-6xl/normal text-5xl font-bold">
                    Justin Silverio&apos;s Journey
                </h3>
                <p className="text-xl/normal md:w-2/3 mx-auto text-[#1e1e1e]">
                    Justin turned his passion for real estate into profit with
                    direct mail. From rehabbing houses to landing deals on
                    fire-damaged properties, he proves its game-changing power.
                </p>
            </div>
            <div className="md:w-4/5 mx-auto">
                <div className="bg-secondary rounded-2xl md:p-3 p-1">
                    <YoutubeEmbed
                        cssClass={'rounded-2xl'}
                        url="https://www.youtube.com/watch?v=MLoqvKtXJ20"
                    />

                    {/* https://www.youtube.com/watch?v=m23R4Nwt1Pc */}
                </div>
            </div>
            <div className="w-96 m-auto">
                <GradientButton onClick={handleClick}>
                    Get Started with Direct Mail
                </GradientButton>
            </div>
        </div>
    )
}
